import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { Consent } from '../../common/Enums'

/**
 * Properties expected when invoking the cookies consent modal
 */
export interface ICookiesConsentModalProps {
    onConsent: (value: Consent) => void
}

/**
 * Prompts the user to made a decision to accept or decline cookie use
 *
 * @returns {JSX.Element} React cookies consent modal component
 */
function CookiesConsentModal(props: ICookiesConsentModalProps) {
    return (
        <Modal show={true}>
            <Modal.Header>
                <Modal.Title aria-label={'Cookie consent modal title'}>
                    Cookie Consent Request
                </Modal.Title>
            </Modal.Header>
            <Modal.Body aria-label={'Cookie consent modal content'}>
                <p>
                    This site uses cookies and local browser storage to perform:
                </p>
                <ul>
                    <li>
                        basic user analytics
                        <ul>
                            <li>Microsoft Clarity</li>
                            <li>no personal information stored</li>
                        </ul>
                    </li>
                    <li>
                        store your settings
                        <ul>
                            <li>autosave</li>
                            <li>focused boards</li>
                            <li>info panel state</li>
                        </ul>
                    </li>
                    <li>
                        store your state
                        <ul>
                            <li>boards</li>
                            <li>swimlanes</li>
                            <li>tasks</li>
                        </ul>
                    </li>
                </ul>
                <p>
                    You can use the application without consenting to cookies,
                    but you will be unable to save your work, however it will be
                    acceptable for evaluation purposes.
                </p>
                <p>
                    If you do decline you will be asked again the next time you
                    visit.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={() => props.onConsent(Consent.Accepted)}
                    aria-label="Accept Button">
                    Accept
                </Button>
                <Button
                    variant="secondary"
                    onClick={() => props.onConsent(Consent.Declined)}
                    aria-label="Decline Button">
                    Decline
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CookiesConsentModal
